import { ModelsPanel } from '@openlayers/models/ui/ModelsPanel';
import { TileLayersPanelComponent } from '@openlayers/tile-layers/ui/TileLayersPanelComponent';
import { ImagesEditor } from '@pages/map/actions/ImagesEditor';
import { MapDocumentsEditor } from '@pages/map/actions/MapDocumentsEditor';
import { mapRootStore, mapStateFacade, mapStation, mapTools, mapUI, mapWrapper, massMap } from '@pages/map/map';
import { BgMapsPanel } from '@pages/map/ui/bg-maps/BgMapsPanel';
import { BgMapsPanelToolbar } from '@pages/map/ui/bg-maps/BgMapsPanelToolbar';
import { LogpointsPanel2dMapComponent } from '@pages/map/ui/logpoints/LogpointsPanel2dMapComponent';
import { LogpointsToolbar } from '@shared/logpoints/ui/LogpointsToolbar';
import { MassAdvancedEditor } from '@pages/map/ui/mass/MassAdvancedEditor';
import { MassGridEditor } from '@pages/map/ui/mass/MassGridEditor';
import { MassPanelList } from '@pages/mass/MassPanelList';
import { SavedViewAttachmentsService } from '@shared/attachments/SavedViewAttachmentsService';
import { DocumentsImagesPanelGenericComponent } from '@shared/documents-images/ui/DocumentsImagesPanelGenericComponent';
import { ExternalDocumentCreateEditDialog } from '@shared/documents/ui/ExternalDocumentCreateEditDialog';
import { PdfTemplateFill } from '@shared/documents/ui/PdfTemplateFill';
import { Events, EventsGlobal } from '@shared/Events';
import { FileFolderDownloadDialog } from '@shared/files/FileFolderDownloadDialog';
import { ImagesService } from '@shared/images/ImagesService';
import { FileTreeService } from '@shared/services/FileTreeService';
import { Drawer } from '@shared/ui-native/Drawer';
import { Button } from '@shared/ui-react/Button';
import { Catch } from '@shared/ui-react/Catch';
import { DialogUtils } from '@shared/ui-react/Dialog';
import { Dropdown } from '@shared/ui-react/Dropdown';
import { WindowManager } from '@shared/ui-react/FloatingWindow';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { SidebarNavTabs } from '@shared/ui-react/SidebarNavTabs';
import { SavedViewsPanelComponent } from '@shared/user-state/ui/SavedViewsPanelComponent';
import { cs } from '@shared/utils/utils-classname';
import { VehiclesPanelGeneric } from '@shared/vehicles/VehiclesPanelGeneric';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Notify } from '@shared/ui-native/Notify';
import { LogpointsEditor2dMap } from '@pages/map/actions/LogpointsEditor2dMap';
import { LogpointsDownloadDialog } from '@shared/logpoints/ui/LogpointsDownloadDialog';


type AllPanels = VehiclesPanelGeneric | ModelsPanel | BgMapsPanel | LogpointsPanel2dMapComponent | DocumentsImagesPanelGenericComponent | MassPanelList | SavedViewsPanelComponent | TileLayersPanelComponent;


@observer
export class Map2dSidebar extends React.Component {
    public activePanel: AllPanels = null;
    @observable public activePanelId: IMapPanelName = null;
    public activePanelIdBeforeCLose: IMapPanelName = null;

    public tabs = [
        this.hasVehicles ? { id: 'vehicles', icon: 'iki iki-equipment', label: __('menu.vehicles') } : null,
        { id: 'models', icon: 'iki iki-models', label: __('menu.models') },
        { id: 'bgMaps', icon: 'iki iki-designs', label: __('menu.select_background_maps') },
        { id: 'documents', icon: 'iki iki-files', label: __('general.documents') },
        this.hasLogpoints ? { id: 'logpoints', icon: 'iki iki-asbuilt', label: __('menu.logpoints') } : null,
        this.hasPhotos ? { id: 'images', icon: 'iki iki-photos', label: __('general.images') } : null,
        this.hasMass ? { id: 'mass', icon: 'iki iki-cross-section', label: __('menu.mass') } : null,
        this.hasSavedViews ? { id: 'savedViews', icon: 'iki iki-saved-views', label: __('menu.saved_views') } : null,
        { id: 'tileLayers', icon: 'iki iki-map-layers', label: __('menu.map_tile_layers') }
        //{ id: 'schedule', icon: 'iki iki-map-layers', label: __('Schedule') }
    ].filter(Boolean)

    public panels: {
        vehicles?: VehiclesPanelGeneric;
        models?: ModelsPanel;
        bgMaps?: BgMapsPanel;
        logpoints?: LogpointsPanel2dMapComponent;
        documents?: DocumentsImagesPanelGenericComponent;
        images?: DocumentsImagesPanelGenericComponent;
        mass?: MassPanelList;
        savedViews?: SavedViewsPanelComponent;
        tileLayers?: TileLayersPanelComponent;
        //schedule?: SchedulePanelList;
    } = null;

    constructor(props) {
        super(props);
        makeObservable(this);

        this.panels = {};

        Events.on(EventsGlobal.MAP_OPEN_IMAGE_FOLDER_WITH_THUMBNAILS, (evt, { folderId, imageId }) => {
            this.activatePanelById('images');
            this.panels.images.openThumbnailsPanel(folderId, imageId);
        });

        Events.on(EventsGlobal.MAP_OPEN_DOCUMENTS_FOLDER_WITH_THUMBNAILS, (evt, { folderId, imageId }) => {
            this.activatePanelById('documents');
            this.panels.documents.openThumbnailsPanel(folderId, imageId);
        });

        Events.on('map-edit-image', (evt, image) => ImagesEditor.open([image], mapRootStore.imagesStore));
        Events.on('map-edit-document', (evt, document) => mapRootStore.executeWithTreeData(treeData => {
            MapDocumentsEditor.openDrawer([document], mapRootStore.documentsStore, treeData, mapWrapper, mapTools)
        }));
    }

    componentDidMount() {
        this.panels.models = new ModelsPanel(document.querySelector('#map-2d-models-panel-wrapper'), mapRootStore.getTreeData(), mapWrapper.featureLayers);
        this.panels.bgMaps = new BgMapsPanel(document.querySelector('#map-2d-maps-panel-wrapper'), mapRootStore.getTreeData());

        Events.on(EventsGlobal.FLOATING_WINDOW_OPENED, (evt, data) => {
            if (data.isMobile) {
                this.closePanel();
            }
        })

        Events.on(EventsGlobal.FLOATING_WINDOW_CLOSED, (evt, data) => {
            if (data.isMobile && this.activePanelIdBeforeCLose) {
                this.activePanelId = this.activePanelIdBeforeCLose;
            }
        })
    }

    render() {

        return (
            <div className={cs('sidebar-panel js-sidebar', {
                mobile: mapRootStore.mobileView,
                fixed: mapRootStore.mobileView,
            })}>
                <nav className="sidebar-panel__tabs">
                    <SidebarNavTabs
                        activeId={this.activePanelId}
                        onChange={id => this.activatePanelById(id as any)}
                        onClose={this.closePanel}
                        isMobile={mapRootStore.mobileView}
                        tabs={this.tabs}
                    />
                </nav>

                {mapRootStore.isInitializing ?
                    <section className='overlay-loading'></section>
                    :
                    <div className="sidebar-panel__panels"
                        style={{ display: !this.activePanelId ? 'none' : 'flex' }}>
                        <div className="sidebar-panel__mobile-close" onClick={this.closePanel}>
                            <i className="iki iki-chevron-left"></i>
                        </div>

                        {/* VEHICLES */}
                        {(this.hasVehicles && this.activePanelId === 'vehicles') && <section>
                            <header className="panel-title with-tabs">{__('menu.vehicles')}</header>
                            <div className="sidebar-toolbar flex-row">
                                <Button secondary subtle icon="iki iki-fit-to-screen" id="vehicles-panel-fit-visible-btn" style={{ marginLeft: 'auto' }} tooltip={__('js_map.fit_visible')} onClick={() => mapWrapper.fitVehiclesLayer()} />
                                {kuura.hasAisIntegrationEnabled() && <Dropdown closeOnBodyClick={false} buttonStyle={{ paddingLeft: 10, paddingRight: 10 }} className='ik-button-secondary--subtle'>
                                    <i className="iki iki-more" />
                                    <div className="no-select">
                                        <div className="dropdown-list-title">{__('general.settings')}:</div>
                                        <ul className="dropdown-list clickable">
                                            <li onClick={mapRootStore.marineStore.toggleShow}><input type="checkbox" checked={mapRootStore.marineStore.showOnMap} readOnly />{__('js_map.show_marine_vessels_on_map')}</li>
                                        </ul>
                                    </div>
                                </Dropdown>}
                            </div>

                            <VehiclesPanelGeneric
                                ref={(el) => this.panels.vehicles = el}
                                treeData={mapRootStore.treeData}
                                store={mapRootStore.vehiclesStore}
                                sidebarWidth={mapRootStore.sidebarWidth}
                                readOnly={false}
                                onFitVisible={null}
                                onPanToVehicle={v => mapWrapper.featureLayers.vehicles.panToVehicle(v.id)}
                                onLoadModels={uuids => {
                                    this.panels.models.checkUuids(uuids);
                                    this.panels.bgMaps.tree.checkUuids(uuids, false, true, false);
                                }}
                            />
                        </section>}

                        {/* MODELS */}
                        <section style={{ display: this.activePanelId === 'models' ? 'flex' : 'none' }} id="map-2d-models-panel-wrapper">
                            <header className="panel-title">{__('menu.models')}</header>
                            <div id="js-app__models-panel__toolbar-wrapper" className="sidebar-toolbar"></div>
                            <div id="js-app__models-panel__tree-wrapper" className="of-a flex-1"></div>
                        </section>

                        {/* MAPS */}
                        <section style={{ display: this.activePanelId === 'bgMaps' ? 'flex' : 'none' }} id="map-2d-maps-panel-wrapper">
                            <header className="panel-title">{__('tablet.maps')}</header>
                            <div id="js-app__maps-panel__toolbar-wrapper" className="sidebar-toolbar">
                                <BgMapsPanelToolbar layer={mapWrapper.backgroundMaps} />
                            </div>
                            <div id="js-app__maps-panel__tree-toolbar"></div>
                            <div id="js-app__maps-panel__selection-feedback"></div>
                            <div id="js-app__maps-panel__tree-wrapper" className="of-a flex-1"></div>
                        </section>

                        {/* LOGPOINTS */}
                        {this.hasLogpoints &&
                            <section style={{ display: this.activePanelId === 'logpoints' ? 'flex' : 'none', flexDirection: 'column' }}>
                                <Catch>
                                    <header className="panel-title">{__('menu.logpoints')}</header>
                                    <nav className="sidebar-toolbar flex-row">
                                        <LogpointsToolbar
                                            mapWrapper={mapWrapper}
                                            onDrawLinecode={() => mapUI.editLogpointsLinecode()}
                                            onBulkEdit={() => LogpointsEditor2dMap.open(null, false, 'area', mapRootStore.treeData)}
                                            onDownload={() => {
                                                const logpointIds = mapWrapper.featureLayers.logpoints.layerSource.getFeatures().map(f => f.get('data').id)
                                                LogpointsDownloadDialog.open(logpointIds)
                                            }}
                                        />
                                    </nav>
                                    <div className="sidebar-section-body">
                                        <LogpointsPanel2dMapComponent
                                            ref={el => this.panels.logpoints = el}
                                            logpointsLayer={mapWrapper.featureLayers.logpoints}
                                            treeData={mapRootStore.treeData}
                                            filterTab={mapRootStore.mobileView}
                                            sidebarWidth={mapRootStore.sidebarWidth}
                                        />
                                    </div>
                                </Catch>
                            </section>
                        }

                        {/* DOCUMENTS */}
                        <section style={{ display: this.activePanelId === 'documents' ? 'flex' : 'none' }} id="map-2d-documents-panel-wrapper">
                            <header className="panel-title">{__('general.documents')}</header>
                            <DocumentsImagesPanelGenericComponent
                                ref={el => this.panels.documents = el}
                                store={mapRootStore.documentsStore}
                                storageKey="documents-images-panel"
                                type="documents"
                                mobileView={mapRootStore.mobileView}
                                treeData={mapRootStore.treeData}
                                pinLeftOffset={mapRootStore.sidebarWidth}
                                toggleExpandPanel={this.toggleExpandPanel}
                                onOpenItem={id => {
                                    const thumbs = mapRootStore.documentsStore.thumbnails
                                    let queue = thumbs.filtered;
                                    if (!queue.find(i => i.id === id)) { // if user chose to show unfiltered thumbnails and clicked on thumbnail, we need to use unfiltered queue
                                        queue = thumbs.unfiltered;
                                    }
                                    mapWrapper.featureLayers.documents.openDocumentById(id, queue.map(i => i.id))
                                }}
                                onEditItem={id => {
                                    const item = mapRootStore.documentsStore.getById(id);
                                    MapDocumentsEditor.openDrawer([item], mapRootStore.documentsStore, mapRootStore.treeData, mapWrapper, mapTools)
                                }
                                }
                                onEditItems={items => MapDocumentsEditor.openDrawer(items as IDocument[], mapRootStore.documentsStore, mapRootStore.treeData, mapWrapper, mapTools)}
                                onCreateExternalDocument={this.openCreateExternalDocument}
                                onOpenFillTemplate={this.openFillTemplate}
                            />
                        </section>

                        {/* PHOTOS */}
                        <section style={{ display: this.activePanelId === 'images' ? 'flex' : 'none' }} id="map-2d-images-panel-wrapper">
                            <header className="panel-title">{__('menu.photos')}</header>
                            <DocumentsImagesPanelGenericComponent
                                ref={el => this.panels.images = el}
                                store={mapRootStore.imagesStore}
                                storageKey="documents-images-panel"
                                type="images"
                                treeData={mapRootStore.treeData}
                                mobileView={mapRootStore.mobileView}
                                pinLeftOffset={mapRootStore.sidebarWidth}
                                toggleExpandPanel={this.toggleExpandPanel}
                                onOpenItem={id => {
                                    const thumbs = mapRootStore.imagesStore.thumbnails
                                    let queue = thumbs.filtered;
                                    if (!queue.find(i => i.id === id)) { // if user chose to show unfiltered thumbnails and clicked on thumbnail, we need to use unfiltered queue
                                        queue = thumbs.unfiltered;
                                    }
                                    mapWrapper.featureLayers.images.openImageById(id, queue.map(i => i.id));
                                }}
                                onEditItem={id => ImagesEditor.openForId(id, mapRootStore.imagesStore)}
                                onEditItems={items => ImagesEditor.open(items as IImage[], mapRootStore.imagesStore)}
                                onOpenUploader={() => mapUI.openImageUploader()}
                                onBulkEdit={() => ImagesEditor.open([], mapRootStore.imagesStore)}
                                onCreateExternalDocument={null}
                            />
                        </section>

                        {/* MASS */}
                        {this.hasMass &&
                            <section style={{ display: this.activePanelId === 'mass' ? 'flex' : 'none' }} id="map-2d-mass-panel-wrapper">
                                <header className="panel-title with-tabs">{__('menu.mass')}</header>
                                <MassPanelList
                                    ref={el => this.panels.mass = el}
                                    massMap={massMap}
                                    treeData={mapRootStore.treeData}
                                    massGridEditor={MassGridEditor}
                                    massAdvancedEditor={MassAdvancedEditor}
                                />
                            </section>
                        }

                        {/* SAVED VIEWS */}
                        {this.hasSavedViews &&
                            <section style={{ display: this.activePanelId === 'savedViews' ? 'flex' : 'none' }}>
                                <SavedViewsPanelComponent
                                    ref={el => this.panels.savedViews = el}
                                    pageStateFacade={mapStateFacade}
                                    treeData={mapRootStore.treeData}
                                    pinLeftOffset={mapRootStore.sidebarWidth}
                                    hasPartialLoadDialog={true}
                                    canShowMarkersOnMap={true}
                                    toggleExpandPanel={this.toggleExpandPanel}
                                    onDownload={this.onDownloadSavedView}
                                />
                            </section>
                        }

                        {/* TILE LAYERS */}
                        <section style={{ display: this.activePanelId === 'tileLayers' ? 'flex' : 'none' }} id="map-2d-tile-panel-wrapper">
                            <header className="panel-title with-tabs">{__('menu.map_tile_layers')}</header>
                            <TileLayersPanelComponent
                                ref={el => this.panels.tileLayers = el}
                                treeData={mapRootStore.treeData}
                                tileLayers={mapWrapper.tileLayers}
                            />
                        </section>

                        {/* SCHEDULE */}
                        {/*<section style={{ display: this.activePanelId === 'schedule' ? 'flex' : 'none' }} id="map-2d-tile-panel-wrapper">*/}
                        {/*    <header className="panel-title with-tabs">{__('Schedule')}</header>*/}
                        {/*    <SchedulePanelList ref={el => this.panels.schedule = el}/>*/}
                        {/*</section>*/}
                    </div>
                }
            </div>
        );
    }

    public toggleExpandPanel = () => {
        const panel: HTMLDivElement = document.querySelector('.sidebar-panel__panels').parentElement.parentElement as HTMLDivElement;
        if (panel.offsetWidth < 600) {
            panel.style.width = '850px';
        }
        else {
            panel.style.width = '420px';
        }
    }

    public activatePanelById = action((id: IMapPanelName): void => {
        if (!id) return;

        this.activePanelId = id;
        this.activePanel = this.panels[id];

        if (mapRootStore.mobileView) {
            WindowManager.closeAll();
        }

        setTimeout(() => {
            $('.sidebar-panel__panels section:visible .file-tree__toolbar__text-filter').focus();
        }, 200);
    })

    public getActivePanelId = (): IMapPanelName => {
        let foundId = 'models';
        Object.entries(this.panels).forEach(([id, panel]) => {
            if (panel === this.activePanel) {
                foundId = id;
            }
        });
        return foundId as IMapPanelName;
    }

    openCreateExternalDocument = () => {
        let folderUuid = kuura.getRootFolderUuid();
        if (mapRootStore.documentsStore.showThumbnailsForFolderId) {
            const node = FileTreeService.findNodeById(mapRootStore.treeData, mapRootStore.documentsStore.showThumbnailsForFolderId, true);
            if (node) {
                folderUuid = node.uuid;
            }
        }
        const drawerElement = Drawer.open();
        Events.trigger('drawer-open.editor');

        ReactUtils.safeUnmountComponentAtNode(drawerElement);

        ReactUtils.safeRender(<>
            <header>
                <div className="padded"><h2 style={{ marginBottom: 0 }}>{__('js_files.new_external_document')}</h2></div>
            </header>
            <ExternalDocumentCreateEditDialog
                treeData={mapRootStore.treeData}
                document={{
                    folderUuid
                }}
                mapWrapper={mapWrapper}
                mapTools={mapTools}
                onSuccess={() => {
                    mapRootStore.documentsStore.fetchAndSet();
                    Drawer.close();
                }}
                onClose={Drawer.close} />
        </>, drawerElement);
    }

    openFillTemplate = () => {
        const getRenamedName = (template: string, description: string, folderUuid: string, latLon: [number, number], doc: IDocument) => {
            const modelSelected = mapUI.mapPanels.panels.models.tree.getSelected();
            const modelName = modelSelected && !modelSelected.isFolder() ? modelSelected.ajaxData?.name : null;
            const folderName = FileTreeService.findNodeByUuid(mapRootStore.treeData, folderUuid ?? doc.folder?.uuid)?.name ?? null;
            description = description ?? doc.description;
            const alignment = {
                alignmentName: FileTreeService.findNodeById(mapRootStore.treeData, mapRootStore.activeAlignment?.modelId)?.name ?? null,
                station: mapUI.stationAndModelInfoBox?.stationInfo?.station
            };
            const bValue = null; // no geolocation on desktop

            return ImagesService.renameImage(
                template, doc.name, folderName, description, new Date(doc.timestamp), latLon, modelName, bValue, alignment, null
            )
        }
        const Body = observer(() => <PdfTemplateFill
            onSaved={document => {
                console.log('onSaved document:', document);
                mapRootStore.documentsStore.fetchAndSet().then(() => {
                    mapUI.mapPanels.panels.documents.tree.getByUuid(document.folder?.uuid).setChecked(1);
                })
                //mapRootStore.documentsStore.items.push(document);
            }}
            onClose={DialogUtils.close}
            getRenamedName={getRenamedName}
            latLon={mapStation.markerLatLon}
            openSavedPdfInFolder={uuid => {
                this.activatePanelById('documents');
                const item = mapRootStore.documentsStore.getByUuid(uuid);
                if (item) {
                    this.panels.documents.openThumbnailsPanel(item.folderId, item.id);
                } else {
                    Notify.warn('Cant find PDF')
                }
            }}
            openSavedPdfOnMap={uuid => {
                const item = mapRootStore.documentsStore.getByUuid(uuid);
                if (item) {
                    mapWrapper.featureLayers.documents.openDocumentById(item.id);
                } else {
                    Notify.warn('Cant find PDF')
                }
            }}
        />)

        WindowManager.open({
            title: __('js_files.fill_template'),
            id: 'template_fill',
            group: 'template_fill',
            showCloseButton: true,
            resize: 'both',
            defaultSizing: {
                width: Math.min(window.innerWidth * 0.5, 1200),
                height: Math.min(window.innerHeight * 0.8, 1200),
            },
            body: <Body/>
        })

    }

    focusFeatureInTree = (id: number) => {
        this.activatePanelById('models');
        this.panels.models.focusItem(id);
    }

    openInFilesPage = (id: number) => {
        this.panels.models.openInFilesPage(id);
    }

    downloadModel = (id: number) => {
        window.open(`/kuura/api/1/file/${id}/get`);
    }

    closePanel = () => {
        this.activePanelIdBeforeCLose = this.activePanelId;
        this.activePanel = null;
        this.activePanelId = null;
    }

    onDownloadSavedView = async (state: IPageState) => {
        let attachIds = [];
        let images = [];
        let documents = [];

        try {
            const imagesState = (state as IMapPageState).data?.panel?.images;
            if (imagesState) {
                images = mapRootStore.imagesStore.getFiltered({
                    showOnMap: true,
                    folderIds: imagesState.checkedFolderIds,
                    text: imagesState.nameAndDescription,
                    type: imagesState.type as any,
                    userIds: imagesState.userIds,
                    fromTimestamp: imagesState.timestamp.from,
                    toTimestamp: imagesState.timestamp.to
                })
            }

            const documentsState = (state as IMapPageState).data?.panel?.documents;
            if (documentsState) {
                documents = mapRootStore.documentsStore.getFiltered({
                    showOnMap: true,
                    type: documentsState.type as any,
                    userIds: documentsState.userIds,
                    text: documentsState.nameAndDescription,
                    folderIds: documentsState.checkedFolderIds,
                    fromTimestamp: documentsState.timestamp.from,
                    toTimestamp: documentsState.timestamp.to
                })
            }

            attachIds = await SavedViewAttachmentsService.getAttachments(state.uuid).then(list => list.attachments.map(a => a.documentId))
        } catch (e) {
            console.log('saved view onDownload error', e);
        }

        FileFolderDownloadDialog.open({
            files: [
                ...(state as IMapPageState).data.panel.models.fileIds,
                ...(state as IMapPageState).data.panel.bgMaps.fileIds,
                ...(documents || []).map(i => i.id),
                ...(attachIds || [])
            ],
            imageIds: [
                ...(images || []).map(i => i.id),
            ]
        })
    }

    get hasVehicles() {
        return kuura.hasPrivilege('VEHICLE_PAGE');
    }

    get hasLogpoints() {
        return kuura.hasPrivilege('LOGPOINTS_PAGE');
    }

    get hasPhotos() {
        return kuura.hasPrivilege('IMAGES_R') || kuura.hasPrivilege('IMAGES_W');
    }

    get hasMass() {
        return kuura.hasPrivilege('MASS_PAGE');
    }

    get hasSavedViews() {
        return kuura.hasPrivilege('SAVED_VIEWS');
    }
}



